import React from 'react';
import { useParams } from 'react-router-dom';
import BrokerageAgreementCreate from './BrokerageAgreementCreate';

const BrokerageAgreementEdit = () => {
  const { id } = useParams();
  // BrokerageAgreementCreate already handles edit mode when id is provided
  return <BrokerageAgreementCreate />;
};

export default BrokerageAgreementEdit;

